<template>
  <section v-if="list.length" class="mt-5">
    <div class="row no-gutters">
      <div class="col pl-2 list-heading">
        {{ $t('reports.reservation-services-reports.reservation-id') }}
      </div>
      <div class="col pl-2 list-heading">
        {{ $t('reports.reservation-services-reports.country') }}
      </div>
      <div class="col pl-2 list-heading">
        {{ $t('reports.reservation-services-reports.service-code') }}
      </div>
      <div class="col pl-2 list-heading">
        {{ $t('reports.reservation-services-reports.service-title') }}
      </div>
      <div class="col pl-2 list-heading">
        {{ $t('reports.reservation-services-reports.reference') }}
      </div>
      <div class="col pl-2 list-heading">
        {{ $t('reports.reservation-services-reports.date-from') }}
      </div>
      <div class="col pl-2 list-heading">
        {{ $t('reports.reservation-services-reports.date-until') }}
      </div>
      <div class="col pl-2 list-heading">
        {{ $t('reports.reservation-services-reports.amount') }}
      </div>
      <div class="col pl-3 list-heading">
        {{ $t('reports.reservation-services-reports.purchase-price') }}
      </div>
      <div class="col pl-3 list-heading">
        {{ $t('reports.reservation-services-reports.sale-price') }}
      </div>
      <div class="col pl-3 list-heading">
        {{ $t('reports.reservation-services-reports.booking-date') }}
      </div>
    </div>
    <ul class="row input-table mt-2">
      <reports-reservations-service-lines-list-item
        v-for="(report, index) in list"
        :key="index"
        :item="report"
      ></reports-reservations-service-lines-list-item>
    </ul>
  </section>
</template>
<script>
export default {
  props: {
    list: {
      default: () => [],
      type: Array,
      required: false
    }
  }
}
</script>

<style scoped>
.list-heading {
  font-family: 'Open Sans Bold';
  font-size: 14px;
  color: #767676;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/reservations-service-lines/List.vue